import angular from 'angular';

const shopServices = angular.module('applicationModule.shopsServices', []);

shopServices.factory('Shop', ['ShopAPI', function (ShopAPI) {
    'use strict';
    return {
        get: function (shopId, appId) {
            return ShopAPI.getShop(shopId, appId);
        },
        create: function (appId) {
            return ShopAPI.create(appId);
        },
        save: function (shop, editMode) {
            if (editMode) {
                return ShopAPI.editShop(shop);
            } else {
                return ShopAPI.createShop(shop);
            }
        },
        getList: function (appId, params) {
            return ShopAPI.getShops(appId, params).then(function (response) {
                return response.data;
            });
        },
        remove: function (shopId) {
            return ShopAPI.removeShop(shopId);
        },
        search: function (appId, search) {
            return ShopAPI.search(appId, search);
        }
    };
}]);

shopServices.service('ShopAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';
    const API_URL = AppsoupAPI.API_URL + '/app/shop/';

    this.getShops = function (appId, params) {
        return $http.get(API_URL, {params: angular.extend(AppsoupAPI.getTableParams(params), {application_id: appId})});
    };

    this.createShop = function (shop) {
        return $http.post(API_URL, shop);
    };

    this.editShop = function (shop) {
        return $http.put(API_URL + shop.id, shop);
    };

    this.create = function (appId) {
        return $http.get(API_URL + 'create', {params: {application_id: appId}});
    };

    this.getShop = function (shopId, appId) {
        return $http.get(API_URL + shopId, {params: {application_id: appId}});
    };

    this.removeShop = function (shopId) {
        return $http.delete(API_URL + shopId);
    };

    this.search = function (appId, search) {
        return $http.get(API_URL + appId + '/types', {params: {search: search}});
    };
}]);

export default shopServices;
